import { GROUP_TYPE } from 'src/utils/config';


export function isVirtual(type) {
  return type === 'bank-transfer';
}
export function isOffline(type) {
  return type === 'off-line';
}
export function isCash(name) {
  return name === 'Cash';
}

// 订单状态码和支付状态配合
export const CODE_TO_ROUTE = {
  100: 'OnGoing', // ongoing
  200: 'FullCashWaiting', // pay waiting
  1080: 'FullPaySuccess', // paysuccess
  1040: 'FullCanceled', // canceled
};
export function codeToRoute(trackingCode, payState) {
  if (payState === 'SUCCESS' || trackingCode === 1080) {
    return CODE_TO_ROUTE[1080];
  }
  return CODE_TO_ROUTE[trackingCode];
}

// ongoing 页面是否需要跳转的条件
export function needJump(code, payState, payment) {
  // 离线支付时，所有人都跳转到paywaiting页面，在线支付不需要
  const jumpCash = code === 200 && isOffline(payment?.paymentType);
  return code === 1040 || code === 1080 || payState === 'SUCCESS' || jumpCash;
}


export const PAY_PATH_MAP = {
  GoPay: 'gopay-waiting',
  ShopeePay: 'shopee-waiting',
  OVO: 'ovo-waiting',
  DANA: 'dana-waiting',
  Cash: 'FullCashWaiting',
  virtual: 'virtual-account',
  QRIS_ONLINE: 'qris-waiting'
}

export const PRODUCT_STATUS = {
  ITEM_GROUP_ACCEPTING: 'ITEM_GROUP_ACCEPTING',
  ITEM_GROUP_PREPARING: 'ITEM_GROUP_PREPARING',
  ITEM_GROUP_SERVED: 'ITEM_GROUP_SERVED',
  ITEM_GROUP_CANCELED: 'ITEM_GROUP_CANCELED',
  ITEM_GROUP_COMPLETED: 'ITEM_GROUP_COMPLETED'
}

export function genGroups(groups, items) {
  if (!groups) return [{ cartItems: items }];
  const gs = groups.reduce((pre, cur) => ({ ...pre, [cur.cartGroupId]: cur }), {});
  items.forEach(it => {
    const group = gs[it.cartGroupId];
    if (gs[it.cartGroupId]) {
      if (group.cartItems) {
        group.cartItems.push(it);
      } else {
        group.cartItems = [it];
      }
    }
  });
  return Object.values(gs) || [];
}

// func
export function transformProductData(data = {}) {
  const { cartGroups, cartItems } = data;
  const { promos, cartPromos } = data;
  const { cartServiceCharge, serviceCharge } = data;
  const { tax } = data;
  // 减去运费的总价，加上运费的总价
  const { grandTotalWithoutShipping, grandTotal } = data;
  const { listTotal, shippingTotal = 0 } = data;
  const { rounding } = data;

  // 减去运费的划线价格
  const listTotalWithoutShipping = listTotal - shippingTotal;

  const groups = genGroups(cartGroups, cartItems);
  return {
    groups,
    items: [...cartItems || []],
    promos: promos || cartPromos || [],
    serviceCharge: cartServiceCharge || serviceCharge || {},
    tax,
    total: grandTotalWithoutShipping || grandTotal,
    delTotal: listTotalWithoutShipping,
    rounding
  }
}

export function validTrackingCode(code) {
  return Object.keys(CODE_TO_ROUTE).includes(`${code}`);
}
export function validPayment(status) {
  return ['FAILED', 'SUCCESS', 'PENDING'].includes(`${status}`);
}

export function isPkg(id) {
  return id === GROUP_TYPE.PACKAGE;
}

// hooks
